import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useCookies } from 'react-cookie';
import { Image, message } from 'antd';
import { fetchProjectList } from 'apis/common/commonApis';
import {
  currencyTypeList,
  PublicState as PublicStateList,
} from 'utils/constant';

import CoinStoreInputModal from './CoinStoreInputModal';
import RegisterButton from 'components/button/RegisterButton';
import DefaultLayout from 'components/layout/DefaultLayout';
import SearchInput from 'components/search/SearchInput';
import TableToolbar from 'components/table/TableToolbar';
import MainTable from 'components/table/MainTable';
import UtcTimer from 'components/etc/UtcTimer';
import CapsuleButtonbleble from 'components/button/CapsuleButton';
import PublicState from 'components/etc/PublicState';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import NoImage from 'components/etc/NoImage';
import { coinStoreApi } from 'apis/sales/coinStoreApis';
import { useTranslation } from 'react-i18next';
/**
 *
 * @returns {코인 상점 조회}
 */
const CoinStoreListPage = () => {
  const { t } = useTranslation();
  const publicState = PublicStateList();
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const today = dayjs().format('YYYY-MM-DD HH:mm');

  const [visible, setVisible] = useState(false);
  const [searchData, setSearchData] = useState();
  const [datas, setDatas] = useState();
  const [selectData, setSelectData] = useState();
  const [projectDropList, setProjectDropList] = useState();

  const handleOpen = (record) => () => {
    if (record) {
      setSelectData(record);
    }
    setVisible(true);
  };

  const handleDelete = (record) => async () => {
    const res = await coinStoreApi.delete(record.coin_product_id);
    if (!res) {
      return false;
    }
    fetchData();
    message.success(t('coinStore.deleteSuccess'));
  };

  const fetchData = async () => {
    const res =
      cookies.server === 'test'
        ? await coinStoreApi.read()
        : await coinStoreApi.coinStoreList_LIVE();

    if (!res) {
      return false;
    }

    let newArr = [];
    res?.map((v, i) => newArr.push({ ...v, key: i }));
    setDatas(newArr);
  };

  const fetchDropData = async () => {
    const resProjectList = await fetchProjectList();
    setProjectDropList(resProjectList);
  };

  const columnsOrigin = [
    {
      title: t('coinStore.table.thumbnailImg'),
      dataIndex: 'thumbnail_url',
      width: '6rem',
      render: (text, record) =>
        record?.thumbnail_url === '' ? (
          <NoImage />
        ) : (
          <Image
            src={record.thumbnail_url}
            alt={`${record.name}`}
            height={60}
            style={{ objectFit: 'contain' }}
          />
        ),
    },
    {
      title: t('coinStore.table.coinProductID'),
      dataIndex: 'coin_product_id',
      width: '6rem',
      sorter: (a, b) => a.coin_product_id - b.coin_product_id,
    },
    {
      title: t('coinStore.table.name'),
      dataIndex: 'name',
      width: '15rem',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: t('coinStore.table.currencyName'),
      dataIndex: 'currency_name',
      width: '7rem',
      render: (text, record) => (
        <p>
          {record.currency_type_name !== null
            ? record.currency_type_name
            : t('coinStore.table.setProduct')}
        </p>
      ),
      sorter: (a, b) =>
        a.currency_type_name.localeCompare(b.currency_type_name),
      filters: currencyTypeList,
      onFilter: (value, record) =>
        record.currency_type_name.indexOf(value) === 0,
    }, // TODO: currency='' 일 경우, set임
    {
      title: t('coinStore.table.projectName'),
      dataIndex: 'project_name',
      width: '13rem',
      render: (text, record) => (
        <p>
          {record.currency_type_name === '세트' ? '-' : record.project_name}
          &nbsp; {record.is_common === 1 && '(공통작품)'}
        </p>
      ),
      sorter: (a, b) => a.project_name.localeCompare(b.project_name),
      filters: projectDropList,
      onFilter: (value, record) => Number(record.projectId) === value,
    },
    {
      title: t('coinStore.table.startDate'),
      dataIndex: 'start_date',
      width: '12rem',
      render: (t, r) => (
        <>
          {r.start_date}
          <UtcTimer startDate={r.from_date} />
        </>
      ),
      sorter: (a, b) => a.start_date.localeCompare(b.start_date),
    },
    {
      title: t('coinStore.table.endDate'),
      dataIndex: 'end_date',
      width: '12rem',
      render: (t, r) => (
        <>
          {r.end_date}
          <UtcTimer endDate={r.end_date} />
        </>
      ),
      sorter: (a, b) => a.end_date.localeCompare(b.end_date),
    },
    {
      title: t('coinStore.table.price'),
      dataIndex: 'price',
      width: '6rem',
      render: (text, record) => <span>{record?.price?.toLocaleString()}</span>,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: t('coinStore.table.isPublic'),
      dataIndex: 'is_public',
      width: '7rem',
      render: (text) => <PublicState value={text} />,
      sorter: (a, b) => a.is_public - b.is_public,
      filters: publicState,
      onFilter: (value, record) => record?.is_public === value,
    },
    {
      title: t('coinStore.table.state'),
      dataIndex: 'state',
      width: '6rem',
      render: (text, record) => (
        <p>
          {record.start_date > today
            ? t('coinStore.table.waitingForSale')
            : record.end_date >= today
            ? t('coinStore.table.onSale')
            : record.end_date < today
            ? t('coinStore.table.endOfSale')
            : ''}
        </p>
      ),
    },
    {
      title: t('coinStore.table.action'),
      width: '13rem',
      render: (text, record) => (
        <>
          <CapsuleButtonbleble
            name='update'
            onClick={handleOpen(record)}
            disabled={authUpdate}
          >
            {t('coinStore.table.editButton')}
          </CapsuleButtonbleble>
          <DeletePopConfirm
            title={t('coinStore.table.deleteConfirm')}
            onConfirm={handleDelete(record)}
            disabled={authUpdate}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchData().catch(console.log);
    fetchDropData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <div>
          <SearchInput
            setSearchData={setSearchData}
            placeholder={t('coinStore.header.inputPlaceHolder')}
          />
        </div>
        <RegisterButton
          name='register'
          onClick={handleOpen()}
          disabled={authUpdate}
        >
          {t('coinStore.header.registerButton')}
        </RegisterButton>
      </TableToolbar>
      <MainTable
        columns={columnsOrigin}
        dataSource={
          searchData
            ? datas?.filter((data) => data.name.indexOf(searchData) !== -1)
            : datas
        }
      />
      {visible && (
        <CoinStoreInputModal
          visible={visible}
          setVisible={setVisible}
          fetchData={fetchData}
          record={selectData}
          setSelectData={setSelectData}
        />
      )}
    </DefaultLayout>
  );
};

export default CoinStoreListPage;
